module.exports = __webpack_public_path__ + "static/img/logo.5fb2d2f8.png";